import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Comment } from 'semantic-ui-react';
import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { ownAnswerWithComments } from '../../selectors';
import Answer from '../../Answers/Detail';
import links from '../../../../links';
import caseViewImage from './case_view_add_a_comment.png';


const OwnAnswer = ({ answer }) => {
    if (answer) {
        return (
            <div className="page-container answer own-answer">
                <Comment.Group><Answer
                    answer={answer}
                />
                </Comment.Group>
                <div className="flex flex-row bg-gray-50 p-4 text-sm font-bold font-body md:items-center">
                    <MagnifyingGlassIcon width={24} height={24} className="mr-3 text-purple-gray-600" />
                    <div className="flex w-full flex-wrap gap-y-3 justify-between">
                        <span className="text-gray-700">Keep learning — Explore related cases by searching our case library.</span>
                        <a href={`${links.consensusMd}?navigation_from=dx-questions`} className="text-teal-400">Search Cases</a>
                    </div>
                </div>
            </div>);
    }

    return (
        <div className="page-container answer own-answer">
            <div className="max-w-4xl mx-auto">
                <div className="mb-4">
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">
                        Visit the
                        {' '}
                        <a
                            href={links.consensusMd}
                            className="text-blue-600 underline"
                        >
                            Homepage
                        </a>
                        {' '} to try our new and improved user experience to add a comment.
                    </h3>
                </div>

                <h4 className="text-base font-medium text-gray-700 mb-3">
                    Follow these steps to add a comment:
                </h4>
                <ol className="list-decimal list-inside text-gray-600 space-y-2">
                    <li>
                        After you click on the Homepage link, you will be taken to ConsensusMD where you can log in.
                    </li>
                    <li>
                        Once you login, click on the Case in the Homepage feed you want to Add a comment for.
                    </li>
                    <li>
                        On the Case detail page, click on the &quot;Add a comment&quot; button (see example below).
                    </li>
                </ol>

                <div className="mt-4 pt-3 border-t">
                    <div className="text-center">
                        <img
                            src={caseViewImage}
                            alt="Case detail page showing the Add a comment button"
                            className="max-w-full h-auto"
                        />
                    </div>
                </div>
            </div>
        </div>);
};

OwnAnswer.propTypes = {
    answer: PropTypes.shape({}),
};

OwnAnswer.defaultProps = {
    answer: null,
};

const mapStateToProps = (state, { topicId }) => ({
    answer: ownAnswerWithComments(topicId)(state),
});

export default connect(mapStateToProps)(OwnAnswer);
